import * as uiActionTypes from '../actionTypes';
import { createSetter } from '../../helpers';
import Name from '..';

export const [setServerError] = createSetter(Name, [uiActionTypes.SETSERVERERROR]);
